var _stop, _stop2, _stop3, _stop4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgProjects(props) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fillOpacity: 0,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.775 6.17c2.178-.437 3.932-2.212 4.37-4.446.439 2.234 2.192 4.009 4.37 4.447m0 .002c-2.178.438-3.932 2.213-4.37 4.447-.439-2.234-2.192-4.009-4.37-4.447",
    stroke: `url(#${_id})`,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.622 7.892l4.377 4.377m-8.624 8.485l-5.8 1.517 1.513-5.816 9.884-9.917c1.176-1.18 3.11-1.264 4.37 0 1.178 1.18 1.178 3.119 0 4.383l-9.967 9.833z",
    stroke: `url(#${_id2})`,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 10.474,
    y1: 10.537,
    x2: 10.474,
    y2: 1.724,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 22.147,
    y1: 22.115,
    x2: 22.147,
    y2: 5.621,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  })))));
}
export default SvgProjects;